import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import instituciones from "../../json/instituciones.json"
import { cardEncuestadores } from "../../service/Service";

const Encuestador = () => {
  const [cardsHome, setCardsHome] = useState({});
  const [isloading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchcard = async () => {
      setIsLoading(true);

      try {
        const response = await cardEncuestadores();
        setCardsHome(response.data.data);
      } catch (error) {
        // Manejo de errores
      }

      setIsLoading(false);
    };

    fetchcard();
  }, [])

  return (
    <div >
      {/* Primera fila */}
      <div className="row" style={{paddingTop:50}}>
        <div className="col-sm-6 mb-3 mb-sm-0 mt-4" style={{paddingLeft:100}}>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{textAlign:'center', fontSize:30}}>Encuestadores con encuestas <br/> últimos 7 días</h5>
              {/* {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>
                  {cardsHome?.enc_con_encuestas_ultimos_7_dias}
                </p>
              )} */}
              <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>70</p>
            </div>
          </div>
        </div>
        <div className="col-sm-6 mt-4" style={{paddingRight: 100}}>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{textAlign:'center', fontSize:30}}>Encuestadores nuevos con encuestas <br/> últimos 7 días</h5>
              {/* {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>
                  {cardsHome?.enc_new_encuestas_ultimos_7_dias}
                </p>
              )} */}
              <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>10</p>
            </div>
          </div>
        </div>
      </div>

      {/* Segunda fila */}
      <div className="row" style={{paddingTop:16}}>
        <div className="col-sm-4 mb-3 mb-sm-0 mt-4" style={{paddingLeft:100}}>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{textAlign:'center', fontSize:30}}>% encuestadores que persisten <br/> últimos 7 días</h5>
              {/* {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>
                  {cardsHome?.enc_persisten_ultimos_7_dias}
                </p>
              )} */}
              <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>90%</p>
            </div>
          </div>
        </div>
        <div className="col-sm-4 mt-4">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{textAlign:'center', fontSize:30}}>% encuestadores nuevos con encuestas <br></br> últimos 7 días</h5>
              {/* {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>
                  {cardsHome?.enc_nuevos_con_encuestas_ultimos_7_dias}
                </p>
              )} */}
              <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>80%</p>
            </div>
          </div>
        </div>

        <div className="col-sm-4 mt-4" style={{paddingRight: 100}}>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{textAlign:'center', fontSize:30}}>% encuestadores con alguna encuesta <br></br> últimos 7  días</h5>
              {/* {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>
                  {cardsHome?.enc_alguna_encuestas_ultimos_7_dias}
                </p>
              )} */}
              <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>90%</p>
            </div>
          </div>
        </div>
        
        <div className="col-sm-3 mt-4" style={{paddingLeft: 100}}></div>
        <div className="col-sm-6 mt-4" style={{paddingTop: 20, paddingBottom: 40}}>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title" style={{textAlign:'center', fontSize:30}}>% encuestadores sin actividad últimos 7 días</h5>
              {/* {isloading ? (
                <div className="d-flex justify-content-center">
                <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                </div>
                </div>
              ) : (
                <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>
                  {cardsHome?.enc_sin_actividad_ultimos_7_dias}
                </p>
              )} */}
              <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>10%</p>
            </div>
          </div>
        </div>
        <div className="col-sm-3 mt-4" style={{paddingRight: 100}}></div>

      </div>
    </div>
  );
};

export default Encuestador;
